import { render, staticRenderFns } from "./BookingListFilters.vue?vue&type=template&id=180e1e3b"
import script from "./BookingListFilters.vue?vue&type=script&lang=js"
export * from "./BookingListFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports